export const Type = {
  PRODUCT_CREATE_ASYNC: "productCreateAsync",
  PRODUCT_CREATE_SUCCESS: "productCreateSuccess",
  PRODUCT_CREATE_FAILURE: "productCreateFailure",
  PRODUCT_UPDATE_ASYNC: "productUpdateAsync",
  PRODUCT_UPDATE_SUCCESS: "productUpdateSuccess",
  PRODUCT_UPDATE_FAILURE: "productUpdateFailure",
  PRODUCT_FETCH_CATEGORIES: "productFetchCategories",
  PRODUCT_LOADING_DONE: "productLoadingDone",
  PRODUCT_LOADING_START: "productLoadingStart",
};
